import React, { Component } from "react";

//import input items for reactPrime
import { Steps } from 'primereact/steps';

//generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";


/*
    props:
        stepperOptions: //a json that contains
        [
            {
                label: "name of stepper",
                index: int,
                command: (event) => {
                    javascript command
                }
            },
        ]
        activeIndex => the page number that is active
        selectFunc => function to set parent state

*/

class Stepper extends Component {

    state = {
    }

    constructor(props) {
        super(props);
        
        //action handler
        this.handleOnSelect = this.handleOnSelect.bind(this);
    }

    handleOnSelect(e) {
        if (!isEmpty(this.props.selectFunc)) {
            this.props.selectFunc(e.index + 1);
        }
    }
 
    render() {
        var currIndex = (!isEmpty(this.props.activeIndex) ? this.props.activeIndex : 1);

        return (
            <div>
                {/* <span className="stepper_stage_num_text">
                    Step {currIndex} of {Object.keys(this.props.stepperOptions).length}
                </span> */}
                <div className="row">
                    <Steps 
                        model={this.props.stepperOptions} 
                        activeIndex={currIndex - 1} 
                        onSelect={(e) => this.handleOnSelect(e)} 
                        readOnly={false} />
                </div>
            </div>
        );
    }
}

export default Stepper;